<div class="container p-4">
  <h4 class="head"><b>Filter Jobs</b></h4>
  <form [formGroup]="careerFilterForm">
      <div class="row">
          <div class="col-lg-4">
              <div>
                  <mat-label class="label">Posted Date</mat-label>
              </div>
              <div>
                  <mat-form-field appearance="outline" class="fields input-font b-r w-100">
                      <input matInput [matDatepicker]="postedDate" formControlName="postedDate"
                          placeholder="dd/mm/yyyy" (dateChange)="onPostedDateSelected($event)">
                      <mat-datepicker-toggle matIconSuffix [for]="postedDate"></mat-datepicker-toggle>
                      <mat-datepicker #postedDate color="primary"></mat-datepicker>
                  </mat-form-field>
              </div>
          </div>

          <div class="col-lg-4">
              <div>
                  <mat-label class="label">Company</mat-label>
              </div>
              <div>
                  <mat-form-field appearance="outline" class="input-font w-100">
                      <input matInput type="text" formControlName="company"
                          (blur)="onCompanyChange($event)"
                          (keydown)="onKeyPress($event, 'company')">
                  </mat-form-field>
              </div>
          </div>

          <div class="col-lg-4">
              <div>
                  <mat-label class="label">Job Category</mat-label>
              </div>
              <div>
                  <mat-form-field appearance="outline" class="input-font w-100">
                      <input type="text" placeholder="Select" aria-label="Number" matInput formControlName="jobCategories"
                          (input)="filterJobCategories($event)"
                          [matAutocomplete]="auto"
                          #autoCompleteJobCategoryInput="matAutocompleteTrigger">

                      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onJobCategorySelected($event)">
                          <mat-option *ngFor="let jobCategory of filteredCategories" [value]="jobCategory.categoryName">
                              {{ jobCategory?.categoryName }}
                          </mat-option>
                      </mat-autocomplete>
                  </mat-form-field>
              </div>
          </div>

          <div class="col-lg-4">
              <div>
                  <mat-label class="label">Skills</mat-label>
              </div>
              <div>
                  <mat-form-field appearance="outline" class="input-font w-100">
                      <input type="text" placeholder="Select" aria-label="Number" matInput formControlName="skills"
                          (input)="filterJobSkills($event)"
                          [matAutocomplete]="autoSkill"
                          #autoCompleteSkillInput="matAutocompleteTrigger">

                      <mat-autocomplete #autoSkill="matAutocomplete" (optionSelected)="onSkillSelected($event)">
                          <mat-option *ngFor="let skill of filteredJobSkills" [value]="skill.name">
                              {{ skill?.name }}
                          </mat-option>
                      </mat-autocomplete>
                      <span class="custom-dropdown-arrow">&#9662;</span>
                  </mat-form-field>
              </div>
          </div>

          <div class="col-lg-4">
              <div>
                  <mat-label class="label">Experience</mat-label>
              </div>
              <div>
                  <mat-form-field appearance="outline" class="input-font w-100">
                      <input matInput type="number" min="0" formControlName="experience"
                          (blur)="onExperienceChange($event)"
                          (keydown)="onKeyPress($event, 'experience')">
                  </mat-form-field>
              </div>
          </div>

          <div class="col-lg-4">
              <div>
                  <mat-label class="label">Country</mat-label>
              </div>
              <div>
                  <mat-form-field appearance="outline" class="input-font w-100">
                      <input type="text" placeholder="Select" aria-label="Number" matInput formControlName="countries"
                          #autoCompleteCountryInput="matAutocompleteTrigger" [matAutocomplete]="countryAuto">
                      <mat-autocomplete #countryAuto="matAutocomplete" (optionSelected)="onCountrySelected($event)">
                          <mat-option *ngFor="let option of countryDropdown" [value]="option?.countryName">
                              {{ option?.countryName }}
                          </mat-option>
                      </mat-autocomplete>
                      <span class="custom-dropdown-arrow">&#9662;</span>
                  </mat-form-field>
              </div>
          </div>

          <div class="col-lg-4">
              <div>
                  <mat-label class="label">State</mat-label>
              </div>
              <div>
                  <mat-form-field appearance="outline" class="input-font w-100">
                      <input type="text" placeholder="Select" aria-label="Number" matInput formControlName="states"
                          [matAutocomplete]="stateAuto" #autoCompleteStateInput="matAutocompleteTrigger"
                          (focus)="onStateFocus()">
                      <mat-autocomplete #stateAuto="matAutocomplete" (optionSelected)="onStateSelected($event)">
                          <mat-option *ngFor="let option of states" [value]="option?.stateName">
                              {{ option?.stateName }}
                          </mat-option>
                      </mat-autocomplete>
                      <span class="custom-dropdown-arrow">&#9662;</span>
                  </mat-form-field>
              </div>
          </div>

          <div class="col-lg-4">
              <div>
                  <mat-label class="label">City</mat-label>
              </div>
              <div>
                  <mat-form-field appearance="outline" class="fields input-font w-100">
                      <input type="text" placeholder="Select" aria-label="Number" matInput formControlName="cities"
                          [matAutocomplete]="cityAuto" (focus)="onCityFocus()" #autoCompleteCityInput="matAutocompleteTrigger">
                      <mat-autocomplete #cityAuto="matAutocomplete" (optionSelected)="onCitySelected($event)">
                          <mat-option *ngFor="let option of cities" [value]="option?.cityName">
                              {{ option?.cityName }}
                          </mat-option>
                      </mat-autocomplete>
                      <span class="custom-dropdown-arrow">&#9662;</span>
                  </mat-form-field>
              </div>
          </div>
          <div class="col-lg-4">
              <div>
                  <mat-label class="label">Status</mat-label>
              </div>
              <div>
                  <mat-form-field appearance="outline" class="fields input-font w-100">
                      <input type="text" placeholder="Select" aria-label="Status" matInput formControlName="status"
                          [matAutocomplete]="statusAuto" (focus)="onStatusFocus()" (input)="filterStatus($event)"
                          #autoCompleteStatusInput="matAutocompleteTrigger">
                      <mat-autocomplete #statusAuto="matAutocomplete" (optionSelected)="onStatusSelected($event)">
                          <mat-option *ngFor="let option of filteredStatusOptions" [value]="option">
                              {{ option }}
                          </mat-option>
                      </mat-autocomplete>
                      <span class="custom-dropdown-arrow">&#9662;</span>
                  </mat-form-field>
              </div>
          </div>
      </div>
      <div *ngIf="chips?.length" class="row-container mt-3">
        <span class="paragraph-medium">Filters applied: </span>
        <mat-chip-set>
            <mat-chip *ngFor="let chip of chips" (removed)="remove(chip)" removable class="chip-style">
                {{ chip?.name }}
                <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
        </mat-chip-set>
    </div>

      <div class="button-container">
          <button type="button" class="button button-primary" (click)="filterCareer()">Filter</button>
          <button class="button button-inverse" (click)="clearCareerFilter()">Clear</button>
          <button class="button button-inverse" (click)="cancelCareerFilter()">Cancel</button>
      </div>
  </form>

</div>
